// @flow
import axios from 'lib/defaultClient';

export const listUserTags = (username: string) => axios.get(`/users/@${username}/tags`);
export const listUserProductsTags = (username: string) =>
  axios.get(`/users/@${username}/products/tags`);
export const getEstimate = (username: string) => axios.get(`/users/@${username}/estimate`);
export const removeEstimate = (username: string, id: string) =>
  axios.delete(`/users/@${username}/estimate/${id}`);
export const updateEstimate = (username: string, id: string) =>
  axios.patch(`/users/@${username}/estimate/${id}`);
export const getEstimateBox = (username: string) => axios.get(`/users/@${username}/estimate-box`);
export const selectEstimateBox = (username: string, id: string) =>
  axios.get(`/users/@${username}/estimate-box/${id}`);
export const removeEstimateBox = (username: string, id: string) =>
  axios.delete(`/users/@${username}/estimate-box/${id}`);
export const getProfile = (username: string) => axios.get(`/users/@${username}`);

type GetHistoryParams = {
  username: string,
  offset?: number,
};

export const getHistory = ({ username, offset }: GetHistoryParams) =>
  axios.get(`/users/@${username}/history?${offset ? `offset=${offset}` : ''}`);



// WEBPACK FOOTER //
// ./src/lib/api/users.js